<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <div class="Privacy">
    <div class="Privacy__text">
      <h1 class="mb-2 text-center">INFORMATIVA</h1>
      <p>
        GLI SPETTATORI PRENDONO ATTO DELLA CIRCOSTANZA CHE IL CONCERTO DEGLI ARTISTI NEGRAMARO, CHE SI TERRÀ OGGI - 12 NOVEMBRE 2020 – SULLE PIATTAFORME A-LIVE OVVERO VIA TEAMS A MEZZO DI EVENT MANAGEMENT, SARÀ REGISTRATO E AUTORIZZANO A-LIVE, EVENT MANAGEMENT E SUGAR S.R.L. A SOCIO UNICO E/O SOGGETTI TERZI DA ESSA AUTORIZZATI A FILMARLI, A REGISTRARE LA LORO IMMAGINE, LA LORO VOCE (INCLUSE LE LORO DICHIARAZIONI) E QUALSIASI LORO ATTEGGIAMENTO E/O COMPORTAMENTO, CHE SI IMPEGNANO AD ASSUMERE NEL RISPETTO DEL DECORO E DELLA MORALE PUBBLICA. ESSI DICHIARANO INOLTRE DI CEDERE A  SUGAR S.R.L. A SOCIO UNICO TUTTI I DIRITTI DI UTILIZZAZIONE - INCLUSI I DIRITTI DI FISSAZIONE E DIFFUSIONE AL PUBBLICO CON QUALSIASI MEZZO TECNICO ESISTENTE E/O DI FUTURA INVENZIONE E CON QUALSIASI MODALITA’ DI FRUIZIONE, SENZA LIMITI DI TEMPO, - DELLA LORO IMMAGINE RELATIVAMENTE ALLA PARTECIPAZIONE IN QUALITÀ DI SPETTATORE AL CONCERTO IVI INCLUSA LA LORO VOCE E LE LORO DICHIARAZIONI. PRENDONO ATTO CHE LA FISSAZIONE E LA DIFFUSIONE AL PUBBLICO È A TITOLO GRATUITO E NULLA HANNO DA OPPORRE E/O DA PRETENDERE DA A-LIVE, EVENT MANAGEMENT E DA SUGAR S.R.L. A SOCIO UNICO PER LA SUINDICATA FISSAZIONE E DIFFUSIONE NONCHE’ PER L’UTILIZZAZIONE DELL’IMMAGINE E DELLE DICHIARAZIONI, AI SENSI DELLA LEGGE 633 DEL 22/04/1941 E DELLA NORMATIVA APPLICABILE.
      </p>

      <h1 class="mt-3 mb-2 text-center">INFORMATION</h1>
      <p>
        THE AUDIENCE HEREBY ACKNOWLEDGES THAT THE NEGRAMARO CONCERT OF 12TH NOVEMBER 2020 MADE ON THE A-LIVE PLATFORMS AND BY TEAMS THROUGHT EVENT MANAGEMENT WILL BE RECORDED FOR BROADCAST AND AUTHORIZES A-LIVE, EVENT MANAGEMENT AND SUGAR S.R.L. A SOCIO UNICO AND/OR THIRD PARTIES AUTHORISED BY THEM TO FILM AND RECORD ANY OF THEIR  IMAGE, VOICE (INCLUDING DECLARATIONS) AND/OR ACTIONS WHATSOEVER, WHICH THEY AKNOWLEDGE TO BE IN COMPLIANCE WITH PUBLIC MORALITY AND DECORUM. THE AUDIENCE DECLARES ALSO TO GRANT TO SUGAR S.R.L. A SOCIO UNICO ALL THE EXPLOITATION RIGHTS – INCLUDING  RECORDING RIGHTS AND BROADCASTING - IN PERPETUITY, FOR ALL MEDIA NOW KNOWN OR HEREAFTER INVENTED, WITHOUT ANY LIMITATION - OF THEIR IMAGE CONCERNING THEIR PARTECIPATION AT THIS CONCERT (INCLUDING THEIR VOICE AND DECLARATIONS). THE AUDIENCE ACKNOWLEDGES ALSO THAT THE RECORDING AND BROADCASTING DOES NOT GIVE ANY ENTITLEMENT TO COMPENSATION OR FEE AND THAT THEY CAN HAVE NO OBJECTION OR CLAIM TOWARDS  A-LIVE, EVENT MANAGEMENT AND SUGAR S.R.L. A SOCIO UNICO FOR THE ABOVE MENTIONED RECORDING AND DISSEMINATION AND FOR THE EXPLOITATION OF THE IMAGES AND THE DECLARATIONS IN ACCORDANCE WITH LAW 633 OF 22 APRIL 1941 AND ANY OTHER APPLICABLE LAW.
      </p>
      <div class="d-flex justify-content-center">
        <router-link to="/negramaro" class="btn btn-dark mt-3">Chiudi</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'privacy',
};
</script>

<style lang="scss" scoped>
  .Privacy {
    display: flex;
    justify-content: center;
    &__text {
      margin: 30px;
      border-radius: 5px;
      flex: 1;
      padding: 30px;
      max-width: 1000px;
      background-color: white;
      p {
        text-align: justify;
      }
    }
  }
</style>
